<template>
  <v-dialog v-model="isVisible" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ isEditMode ? "Edit " : "Add New " }} {{ type }} Template</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="field.name"
                label="Template Name *"
                required
                :error="!(field.name && field.name.length) && isFormDirty"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="field.description"
                label="Template Description *"
                required
                :error="!(field.description && field.description.length) && isFormDirty"
              />
            </v-col>
            <v-col v-if="selectedTemplateType === 3 || selectedTemplateType === 1" cols="12">
              <v-text-field
                v-model="field.flowId"
                :label="selectedTemplateType === 3 ? 'Flow ID *' : 'Flow ID'"
                :required="selectedTemplateType === 3 ? true : false"
                :error="
                  selectedTemplateType === 3
                    ? !(field.flowId && field.flowId.length) && isFormDirty
                    : false
                "
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="selectedTemplateType"
                :items="templateTypes"
                label="Select Template Type *"
                required
                :error="selectedTemplateType === 0 && isFormDirty"
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="selectedTemplateCategory"
                item-text="TemplateCategory"
                item-value="TemplateCategoryID"
                :items="templateCategories"
                label="Select Template Category *"
                required
                :error="selectedTemplateCategory < 1 && isFormDirty"
              />
            </v-col>
            <v-col v-if="selectedTemplateType === 2" cols="12">
              <v-text-field
                v-model="field.emailSubject"
                label="Email subject"
                required
                :error="!((this.selectedTemplateType === 2) && (!this.field.emailSubject || !this.field.emailSubject.length)) && isFormDirty"
                @change="emailSubjectChange($event)"
              />
            </v-col>
          </v-row>
          <v-row>
            <div class="placeHoldersWrapper">
              <div class="label">
                Select a placeholder to insert:
              </div>
              <div class="placeholderSelectorWrapper">
                <label class="dropdown">
                  <div class="dd-button">
                    Select
                  </div>

                  <input id="test" type="checkbox" class="dd-input" />

                  <ul class="dd-menu">
                    <li
                      v-for="templatePlaceholder in templatePlaceholders"
                      :key="templatePlaceholder.TemplateParam"
                      @click="insertPlaceHolder(templatePlaceholder.TemplateParam)"
                    >
                      {{ templatePlaceholder.TemplateParam }}
                    </li>
                  </ul>
                </label>
              </div>
            </div>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea ref="textField" v-model="field.body" label="Template Body" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" v-if="selectedTemplateType !== 3">
              <input ref="file" type="file" style="display: none" @change="onFileChange" />
              <div v-if="!!file || (mediaUrl && mediaUrl.length)" class="fileWrapper">
                <div class="filePart">
                  <div class="iconWrapper">
                    <v-icon>mdi-file</v-icon>
                  </div>
                  <div class="nameWrapper">
                    {{
                      file && file.name
                        ? file.name
                        : mediaUrl.split("/")[mediaUrl.split("/").length - 1]
                    }}
                    <div class="fileSize">Size: {{ file ? formatMemory(file.size) : "" }}</div>
                  </div>
                </div>
                <div class="actionPart" @click="$refs.file.click()">
                  <div class="changeBtn">
                    <v-icon>mdi-refresh</v-icon>
                    Change
                  </div>
                  <div class="removeBtn" @click="onFileDelete">
                    <v-icon>mdi-delete</v-icon>
                  </div>
                </div>
              </div>
              <div
                v-if="!(!!file || (mediaUrl && mediaUrl.length))"
                class="uploadBtn"
                @click="$refs.file.click()"
              >
                <div class="iconWrapper">
                  <v-icon>mdi-attachment</v-icon>
                </div>
                <div class="labelWrapper">
                  Attach an image
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
        <small>* Indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn class="submitBtn" text @click="submit">
          {{ isEditMode ? "Update" : "Add" }}
        </v-btn>
        <v-btn class="testBtn" text @click="_showTestPopup"> Test </v-btn>
        <v-btn class="cancelBtn" text @click="close"> Cancel </v-btn>
      </v-card-actions>
      <v-snackbar v-model="snackbar">
        {{ notification }}

        <template v-slot:action="{ attrs }">
          <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-card>
    <template-tester
      :is-visible="isTestPopupVisible"
      :template-type="selectedTemplateType"
      :template-data="field"
      @on-dismiss="_hidetestPopup"
    />
  </v-dialog>
</template>

<script>
  /* eslint-disable */
  import { VueMaskDirective } from "v-mask";
  import Vue from "vue";
  import TemplateTester from "../../../../entities/template/template-tester/template-tester.vue";
  import UserHelper from "../../../../utils/user-helper";
  import { ApiCalls } from "../../../../api-calls";
  import HelperMethods from "../../../../utils/helper-methods";

  Vue.directive("mask", VueMaskDirective);

  export default {
    name: "SystemTemplateAddEditDialog",
    components: {
      TemplateTester
    },
    props: {
      isVisible: {
        type: Boolean,
        default: false
      },
      isEditMode: {
        type: Boolean,
        default: false
      },
      selectedTemplate: {
        type: Object,
        default: null
      },
      templateCategories: {
        type: Array,
        default: null
      },
      templatePlaceholders: {
        type: Array,
        default: null
      },
      allTemplates: {
        type: Array,
        default: null
      },
      selectedPractice: {
        type: Object,
        default: null
      },
      type: {
        type: String,
        default: "System"
      }
    },
    data: () => ({
      username: null,
      snackbar: false,
      notification: "",
      mediaUrl: "",
      field: {
        name: "",
        body: "",
        description: "",
        flowId: "",
        emailSubject: ""
      },
      selectedTemplateCategory: 0,
      file: null,
      selectedTemplateType: 0,
      allTemplateTypes: [
        {
          text: "SMS Template",
          value: 1
        },
        {
          text: "Email Template",
          value: 2
        },
        {
          text: "IVR Template",
          value: 3
        }
      ],
      templateTypes: [],
      isFormDirty: false,
      isTestPopupVisible: false
    }),

    watch: {
      isVisible(val) {
        if (val) {
          this.isFormDirty = false;

          // Dialog opened
          this.templateTypes = Object.assign([], this.allTemplateTypes);
          if (this.type === 'System') {
            this.templateTypes.splice(2, 1);
          }

          if (this.isEditMode) {
            // Opening in edit mode
            // Assign exisiting entry values
            if (this.selectedTemplate.Name && this.selectedTemplate.Name.length) {
              this.field.name = this.selectedTemplate.Name;
            }
            if (this.selectedTemplate.TemplateEmailSubject && this.selectedTemplate.TemplateEmailSubject.length) {
              this.field.emailSubject = this.selectedTemplate.TemplateEmailSubject;
            }
            if (this.selectedTemplate.Description && this.selectedTemplate.Description.length) {
              this.field.description = this.selectedTemplate.Description;
            }
            if (this.selectedTemplate.FlowID && this.selectedTemplate.FlowID.length) {
              this.field.flowId = this.selectedTemplate.FlowID;
            }
            if (this.selectedTemplate.TemplateBody && this.selectedTemplate.TemplateBody.length) {
              this.field.body = this.selectedTemplate.TemplateBody;
            }
            if (this.selectedTemplate.MediaURL && this.selectedTemplate.MediaURL.length) {
              this.mediaUrl = this.selectedTemplate.MediaURL;
            }
            this.selectedTemplateType = this.selectedTemplate.TemplateTypeID;
            this.selectedTemplateCategory = this.selectedTemplate.TemplateCategoryID;
          } else {
            // Opening in add mode
            // Reset all fields
            this.field = Object.assign({
              name: "",
              body: ""
            });
            this.selectedTemplateType = 0;
            this.selectedTemplateCategory = 0;

            this.isTestPopupVisible = false;
          }
        } else {
          this.file = null;
          this.mediaUrl = "";
        }
      }
    },

    created() {
      this.username = localStorage.getItem("username");
    },

    methods: {

      emailSubjectChange(val) {
        this.field.emailSubject = val;
      },

      initialize() { },

      _showTestPopup() {
        this.isFormDirty = true;
        if (!this.isFormValid()) {
          this.snackbar = true;
          return;
        }
        this.isTestPopupVisible = true;
      },

      _hidetestPopup() {
        this.isTestPopupVisible = false;
      },

      close() {
        this.$emit("on-close");
      },

      isFormValid() {
        this.notification = "";
        if (!this.field.name || !this.field.name.length) {
          this.snackbar = true;
          this.notification = "Please enter a name of the template";
          return false;
        }
        if (this._hasDuplicateFieldName()) {
          this.snackbar = true;
          this.notification = "Template already exists with same name";
          return false;
        }
        if (!this.field.description || !this.field.description.length) {
          this.snackbar = true;
          this.notification = "Please enter a description of the template";
          return false;
        }
        if (this.selectedTemplateType === 3 && (!this.field.flowId || !this.field.flowId.length)) {
          this.snackbar = true;
          this.notification = "Please provide flow id";
          return false;
        }
        if (this.selectedTemplateCategory === 0) {
          this.snackbar = true;
          this.notification = "Please select a template category";
          return false;
        }
        if (this.selectedTemplateType === 0) {
          this.snackbar = true;
          this.notification = "Please select a template type";
          return false;
        }
        if (!this.field.body || !this.field.body.length) {
          this.snackbar = true;
          this.notification = "Template body can not be blank";
          return false;
        }
        if ((this.selectedTemplateType === 2) && (!this.field.emailSubject || !this.field.emailSubject.length)) {
          this.snackbar = true;
          this.notification = "Template subject can not be blank";
          return false;
        }
        return true;
      },

      _hasDuplicateFieldName() {
        let isDuplicate = false;
        if (this.allTemplates && this.allTemplates.length) {
          this.allTemplates.forEach((template) => {
            if (this.isEditMode) {
              if (template.TemplateID !== this.selectedTemplate.TemplateID) {
                if (
                  template.Name &&
                  template.Name.length &&
                  this.field.name &&
                  this.field.name.length &&
                  template.Name.trim().toLowerCase() === this.field.name.trim().toLowerCase()
                ) {
                  isDuplicate = true;
                }
              }
            } else if (
              template.Name &&
              template.Name.length &&
              this.field.name &&
              this.field.name.length && 
              template.Name.trim().toLowerCase() === this.field.name.trim().toLowerCase()
            ) {
              isDuplicate = true;
            }
          });
          return isDuplicate;
        }
      },

      insertPlaceHolder(placeholder) {
        // this.field.body = `${this.field.body} ${placeholder}`
        // Get the input element by tag name, using the ref as a base for the search
        // This is more vue-friendly and plays nicer when you duplicate components
        const el = this.$refs.textField.$el.querySelector("textarea");

        // Insert text into current position
        let cursorPos = el.selectionEnd; // Get current Position
        this.field.body = `${this.field.body.substring(
          0,
          cursorPos
        )} ${placeholder} ${this.field.body.substring(cursorPos)}`;

        // Get new cursor position
        cursorPos += this.field.body.length;
      },

      onFileChange(e) {
        const allowedFileTypes = ["image/jpeg", "image/gif", "image/png"];
        const uploadedFile = e.target.files[0];
        // Check if file type is valid
        if (allowedFileTypes.indexOf(uploadedFile.type) > -1) {
          // Check if it exceeds the size limit
          const allowedFileSize = process.env.VUE_APP_MMS_ATTACHMENT_SIZE_LIMIT_IN_KB || 4 * 1024;
          if (uploadedFile.size / 1024 <= allowedFileSize) {
            // eslint-disable-next-line prefer-destructuring
            this.file = e.target.files[0];
          } else {
            this.notification = `File size too large, maximum allowed size is ${allowedFileSize /
              1024} MB`;
            this.snackbar = true;
          }
        } else {
          this.notification = "The selected file type is not allowed";
          this.snackbar = true;
        }
      },

      onFileDelete() {
        this.file = null;
      },

      async uploadFile() {
        try {
          const formData = new FormData();
          formData.append("file", this.file);
          const res = await ApiCalls.uploadMedia(formData);
          return res.data;
        } catch (error) {
          console.log("error :>> ", error);
          return "";
        }
      },

      formatMemory(x) {
        const units = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        let l = 0;
        let n = parseInt(x, 10) || 0;

        while (n >= 1024 && ++l) {
          // eslint-disable-next-line operator-assignment
          n = n / 1024;
        }
        // include a decimal point and a tenths-place digit if presenting
        // less than ten of KB or greater units
        // eslint-disable-next-line prefer-template
        return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + units[l];
      },

      async submit() {
        this.isFormDirty = true;

        if (!this.isFormValid()) {
          this.snackbar = true;
          return;
        }

        if (!HelperMethods.validateMessagePlaceholders(this.field.body)) {
          this.snackbar = true;
          this.notification = 'First name and Last name in the same message violates HIPAA laws';
          return;
        }

        let systemTemplate = 1;

        if (this.type === 'Practice') {
          systemTemplate = 0;
        }

        if (this.isEditMode) {

          let { mediaUrl } = this;

          if (this.file) {
            mediaUrl = await this.uploadFile();
          }

          console.log(this);

          // Update
          const payload = {
            TemplateBody: this.field.body,
            Name: this.field.name,
            PracticeID: this.type === 'Practice' ? this.selectedPractice.PracticeID : null,
            TemplateID: this.selectedTemplate != null ? this.selectedTemplate.TemplateID : null,
            TemplateTypeID: this.selectedTemplateType,
            TemplateCategoryID: this.selectedTemplateCategory,
            Description: this.field.description,
            MediaURL: mediaUrl,
            Systemtemplate: systemTemplate,
            FlowID: this.field.flowId,
            TemplateEmailSubject: this.field.emailSubject
          };

          if (this.type === "Practice" && this.selectedPractice) {
            payload.PracticeID = this.selectedPractice.PracticeID;
          }

          this.$emit("on-submit");

          try {
            await ApiCalls.editTemplate(payload).then(x => {
              this.$emit("on-success");
              console.log(x);
            });
            this.close();
          } catch (error) {
            this.$emit("on-error", error);
          }

        } else {
          // Add
          let mediaUrl = "";

          if (this.file) {
            mediaUrl = await this.uploadFile();
          }

          console.log(this);

          const payload = {
            TemplateBody: this.field.body,
            Name: this.field.name,
            PracticeID: this.type === 'Practice' ? this.selectedPractice.PracticeID : null,
            TemplateTypeID: this.selectedTemplateType,
            TemplateCategoryID: this.selectedTemplateCategory,
            Description: this.field.description,
            MediaURL: mediaUrl,
            FlowID: this.field.flowId,
            Systemtemplate: systemTemplate,
            TemplateEmailSubject: this.field.emailSubject
          };

          if (this.type === "Practice" && this.selectedPractice) {
            payload.PracticeID = this.selectedPractice.Practice_ID;
          }

          this.$emit("on-submit");

          try {
            await ApiCalls.createTemplate(payload).then(x => {
              this.$emit("on-success");
              console.log(x);
            });
            this.close();
          } catch (error) {
            this.$emit("on-error", error);
          }
        }
      }
    }
  };
</script>
<style scoped lang="scss">
.placeHoldersWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 15px 15px;
  margin-top: 25px;
  margin-bottom: 15px;
  background-color: rgb(116, 116, 116);
  border-radius: 8px;
}
.label {
  color: white;
  font-weight: 600;
}

.dropdown {
  display: inline-block;
  position: relative;
}

.dd-button {
  display: inline-block;
  border: 1px solid gray;
  border-radius: 4px;
  padding: 4px 80px 4px 60px;
  background-color: #ffffff;
  cursor: pointer;
  font-size: 1rem;
  white-space: nowrap;
}

.dd-button:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid black;
}

.dd-button:hover {
  background-color: #eeeeee;
}

.dd-input {
  display: none;
}

.dd-menu {
  position: absolute;
  top: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0;
  margin: 0 0 0 0;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  list-style-type: none;
  z-index: 99999;
}

.dd-input + .dd-menu {
  display: none;
}

.dd-input:hover + .dd-menu {
  display: block;
}

.dd-menu li {
  width: 180px;
  padding: 0px 20px;
  cursor: pointer;
  white-space: nowrap;
}

.dd-menu li:hover {
  background-color: #f6f6f6;
}

.dd-menu li a {
  display: block;
  margin: -10px -20px;
  padding: 10px 20px;
}

.dd-menu li.divider {
  padding: 0;
  border-bottom: 1px solid #cccccc;
}
.fileWrapper {
  margin: 15px 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 7px 25px;
  border: 1px solid rgb(0, 182, 91);
  border-radius: 4px;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.15);
  .filePart {
    flex: 7;
    display: flex;
    align-items: center;
    .iconWrapper {
      margin-right: 12px;
      color: rgb(0, 182, 91);
      * {
        color: rgb(0, 182, 91);
      }
    }
    .nameWrapper {
      margin-top: 3px;
      font-size: 0.9rem;
      font-weight: 400;
      line-height: 18px;
      .fileSize {
        font-size: 0.7rem;
        font-weight: 600;
      }
    }
  }
  .actionPart {
    flex: 3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .changeBtn {
      background-color: rgb(56, 179, 255);
      padding: 0px 15px;
      cursor: pointer;
      font-weight: 600;
      color: white;
      * {
        font-size: 1.3rem;
        color: white;
        margin-top: -4px;
      }
      border-radius: 50px;
      font-size: 0.8rem;
    }
    .removeBtn {
      cursor: pointer;
      * {
        color: rgb(251, 59, 59);
      }
    }
  }
}
.uploadBtn {
  margin: 15px 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 7px 25px;
  justify-content: center;
  cursor: pointer;
  border: 1px solid rgb(0, 182, 91);
  border-radius: 4px;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.15);
  .iconWrapper {
    margin-right: 12px;
    color: rgb(0, 182, 91);
    * {
      color: rgb(0, 182, 91);
    }
  }
  .labelWrapper {
    color: rgb(0, 182, 91);
    margin-top: 3px;
    font-size: 0.9rem;
    font-weight: 400;
  }
  &:hover {
    box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.088);
  }
}
.submitBtn {
  background-color: rgb(0, 182, 91);
  color: white;
}
.cancelBtn {
  background-color: rgba(0, 182, 91, 0);
  color: rgb(252, 59, 59);
}
.testBtn {
  background-color: rgba(0, 182, 91, 0);
  color: rgb(82, 82, 82);
}
</style>
